import React, { useState, useEffect } from 'react';
import { renderIcon } from '../../utils/iconRenderer';
import {
    BarChart, Bar, AreaChart, Area, XAxis, YAxis,
    CartesianGrid, Tooltip, ResponsiveContainer
} from 'recharts';
import { activityData, growthData } from '../../data/mockData';
import { db } from '../../firebase';
import { collection, onSnapshot, getCountFromServer } from 'firebase/firestore';

const OverviewModule = () => {
    const [stats, setStats] = useState([
        { id: 1, title: 'Total Users', value: '0', change: '+0%', type: 'users_nav', color: '#2B7FD9' },
        { id: 2, title: 'Active Groups', value: '0', change: '+0%', type: 'groups_nav', color: '#10B981' },
        { id: 3, title: 'Total Posts', value: '0', change: '+0%', type: 'posts_nav', color: '#F59E0B' },
    ]);

    useEffect(() => {
        // Fetch Real-time stats
        const fetchStats = async () => {
            try {
                // Get counts
                const usersCount = await getCountFromServer(collection(db, 'users'));
                const groupsCount = await getCountFromServer(collection(db, 'groups'));
                const postsCount = await getCountFromServer(collection(db, 'posts'));

                setStats(prev => [
                    { ...prev[0], value: usersCount.data().count.toLocaleString() },
                    { ...prev[1], value: groupsCount.data().count.toLocaleString() },
                    { ...prev[2], value: postsCount.data().count.toLocaleString() }
                ]);
            } catch (error) {
                console.error("Error fetching stats:", error);
            }
        };

        fetchStats();

        // You could also use onSnapshot for real-time updates if preferred
        const unsubscribeUsers = onSnapshot(collection(db, 'users'), () => fetchStats());
        const unsubscribeGroups = onSnapshot(collection(db, 'groups'), () => fetchStats());

        return () => {
            unsubscribeUsers();
            unsubscribeGroups();
        };
    }, []);
    return (
        <div className="content-section">
            <h2 className="content-title">Dashboard Overview</h2>

            <div className="stats-grid">
                {stats.map((stat) => (
                    <div key={stat.id} className="stat-card" style={{ '--accent-color': stat.color }}>
                        <div className="stat-icon">{renderIcon(stat.type, 28)}</div>
                        <div className="stat-content">
                            <h3 className="stat-title">{stat.title}</h3>
                            <p className="stat-value">{stat.value}</p>
                            <span className="stat-change positive">{stat.change}</span>
                        </div>
                    </div>
                ))}
            </div>

            <div className="charts-section">
                <div className="chart-card">
                    <div className="chart-header-row">
                        {renderIcon('activity', 24)}
                        <h3>Recent Activity</h3>
                    </div>
                    <div style={{ width: '100%', height: 240 }}>
                        <ResponsiveContainer width="100%" height="100%">
                            <BarChart data={activityData}>
                                <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="var(--border-light)" />
                                <XAxis dataKey="name" axisLine={false} tickLine={false} tick={{ fontSize: 12, fill: 'var(--text-tertiary)' }} />
                                <YAxis axisLine={false} tickLine={false} tick={{ fontSize: 12, fill: 'var(--text-tertiary)' }} />
                                <Tooltip
                                    contentStyle={{ backgroundColor: 'var(--bg-card)', border: '1px solid var(--border-light)', borderRadius: '12px' }}
                                    itemStyle={{ fontSize: 12 }}
                                />
                                <Bar dataKey="posts" fill="#2B7FD9" radius={[4, 4, 0, 0]} />
                                <Bar dataKey="comments" fill="#10B981" radius={[4, 4, 0, 0]} />
                            </BarChart>
                        </ResponsiveContainer>
                    </div>
                </div>
                <div className="chart-card">
                    <div className="chart-header-row">
                        {renderIcon('revenue', 24)}
                        <h3>User Growth</h3>
                    </div>
                    <div style={{ width: '100%', height: 240 }}>
                        <ResponsiveContainer width="100%" height="100%">
                            <AreaChart data={growthData}>
                                <defs>
                                    <linearGradient id="colorUsers" x1="0" y1="0" x2="0" y2="1">
                                        <stop offset="5%" stopColor="#8B5CF6" stopOpacity={0.3} />
                                        <stop offset="95%" stopColor="#8B5CF6" stopOpacity={0} />
                                    </linearGradient>
                                </defs>
                                <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="var(--border-light)" />
                                <XAxis dataKey="name" axisLine={false} tickLine={false} tick={{ fontSize: 12, fill: 'var(--text-tertiary)' }} />
                                <YAxis axisLine={false} tickLine={false} tick={{ fontSize: 12, fill: 'var(--text-tertiary)' }} />
                                <Tooltip
                                    contentStyle={{ backgroundColor: 'var(--bg-card)', border: '1px solid var(--border-light)', borderRadius: '12px' }}
                                    itemStyle={{ fontSize: 12, color: '#8B5CF6' }}
                                />
                                <Area type="monotone" dataKey="users" stroke="#8B5CF6" fillOpacity={1} fill="url(#colorUsers)" strokeWidth={3} />
                            </AreaChart>
                        </ResponsiveContainer>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default OverviewModule;
